import React, { Component } from 'react';
export default class Currency extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showeble:0
        };
    }    
    componentWillReceiveProps(){
        // let amount = parseFloat(this.props.amount)
        // if(!!this.props.sharing && parseFloat(this.props.sharing)>0 ){
        //     amount = (parseFloat(this.props.sharing)* amount) / 100
        // }
        // if(!!this.props.showInverse && this.props.showInverse === true){
        //     amount = 0-amount   
        // }
        // amount = parseFloat(amount).toFixed(2)
        // this.setState({showeble:amount})
    }
    componentDidMount(){
        // let amount = parseFloat(this.props.amount)
        // if(!!this.props.sharing && parseFloat(this.props.sharing)>0 ){
        //     amount = (parseFloat(this.props.sharing)* amount) / 100
        // }
        // if(!!this.props.showInverse && this.props.showInverse === true){
        //     amount = 0-amount   
        // }
        // amount = parseFloat(amount).toFixed(2)
        // this.setState({showeble:amount})
    }
    getShowable(){
        let amount = parseFloat(this.props.amount)
        if(!!this.props.sharing && parseFloat(this.props.sharing)>0 ){
            amount = (parseFloat(this.props.sharing)* amount) / 100
        }
        if(!!this.props.showInverse && this.props.showInverse === true){
            amount = 0-amount   
        }

        if(!!this.props.isOnlyNumber){
            amount = Math.round(amount)
        }
        else{
            amount = parseFloat(amount).toFixed(2)  
        }

        return amount
    }
    render() {
        let clsname = this.props.className;
        let showable = this.getShowable()
        if (this.props.showColor) {
            if (showable < 0) {
                clsname += " text-red"
            } else if (showable > 0){
                clsname += " text-green"
            } else {
                clsname += " text-dark"
            } 
        }
        return (
            <span className={!!clsname ? clsname : ""}>{showable}</span>
        )
    }
}
